exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.el-message-box-stack{width: 900px !important;\n}\n.myBox{z-index: 9999999 !important;\n}\n.myBox .el-message-box__status{top:40px !important;\n}\n.myBox .el-message-box__message-content > p{\n  overflow:scroll; word-wrap:break-word; word-break:normal;\n  height: 400px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"id":"data-v-248af6a0","scoped":false,"hasInlineConfig":true}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/messageWindow/MessageWindow.vue
// module id = 1109
// module chunks = 159